function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 5");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Accept-Decline-Other",
  transform: "translate(-71.000000, -38.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#418600",
  cx: 26,
  cy: 26,
  r: 26
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FAFAFA",
  fillRule: "nonzero",
  points: "18.9020215 32.884978 14.0742838 28.0944898 12 30.1514072 18.9018455 37 39 17.0569174 36.9270886 15"
})))));

var SvgRespondAttending = function SvgRespondAttending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRespondAttending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/respond_attending.9a1409e8.svg";
export { ForwardRef as ReactComponent };